<script>
  import { Router, Route } from "svelte-routing"
  import {
    Groups,
    Roles,
    Users,
    Applications,
    User,
    Role,
    Group,
    App,
    Home,
    Page404,
    Apps,
    AdminApp,
    AdminContracts,
  } from "./pages/index"
  import callout from "./stores/callout"
  import { createEventDispatcher, getContext, onMount } from "svelte"
  import { user as userStore, contract as contractStore } from "./stores/index"
  import { api } from "./services"
  const { fetchPolicies } = getContext("isAuthorized")
  import "./app.css"

  const dispatch = createEventDispatcher()
  export let user
  export let contract
  export let language
  export let apiurl

  api.init({ apiurl })

  import { addMessages, init } from "svelte-i18n"
  import en from "./i18n/en.json"
  import de from "./i18n/de.json"

  addMessages("en", en)
  addMessages("de", de)
  init({ fallbackLocale: "en", initialLocale: language })

  $: if ($callout) {
    dispatch("callout", { callout: $callout })
  }

  $: {
    userStore.set(user)
    contractStore.set(contract)
  }

  onMount(() => {
    fetchPolicies()
  })
</script>

<Router>
  <Route component={Page404} />

  <!-- admin different routing -->
  <Route path="/admin/contracts" component={AdminContracts} />

  <Route path="/admin/apps" component={Apps} />
  <Route path="/admin/apps/:id/*" let:params>
    <AdminApp id={params.id} />
  </Route>

  <Route path="/contracts/:CON" component={Home} />
  <Route path="/contracts/:CON/users" component={Users} />

  <Route path="/contracts/:CON/users/:id/*" let:params>
    <User id={params.id} />
  </Route>

  <Route path="/contracts/:CON/roles" component={Roles} />
  <Route path="/contracts/:CON/roles/:id/*" let:params>
    <Role id={params.id} />
  </Route>

  <Route path="/contracts/:CON/groups" component={Groups} />
  <Route path="/contracts/:CON/groups/:id/*" let:params>
    <Group id={params.id} />
  </Route>

  <Route path="/contracts/:CON/applications" component={Applications} />
  <Route path="/contracts/:CON/applications/:id/*" let:params>
    <App id={params.id} />
  </Route>
</Router>

<style>
  :global(.gl-autocomplete-results) {
    z-index: 10;
  }
</style>
